import { render, staticRenderFns } from "./menuDat.vue?vue&type=template&id=6da8332b&scoped=true"
import script from "./menuDat.vue?vue&type=script&lang=js"
export * from "./menuDat.vue?vue&type=script&lang=js"
import style0 from "./menuDat.vue?vue&type=style&index=0&id=6da8332b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8332b",
  null
  
)

export default component.exports